import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/init.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm init <package-spec> (same as \`npx <package-spec>)
npm init <@scope> (same as \`npx <@scope>/create\`)

aliases: create, innit
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/init.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p><inlineCode parentName="p">{`npm init <initializer>`}</inlineCode>{` can be used to set up a new or existing npm
package.`}</p>
    <p><inlineCode parentName="p">{`initializer`}</inlineCode>{` in this case is an npm package named `}<inlineCode parentName="p">{`create-<initializer>`}</inlineCode>{`,
which will be installed by `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-exec"
      }}><inlineCode parentName="a">{`npm-exec`}</inlineCode></a>{`, and then have its
main bin executed -- presumably creating or updating `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` and
running any other initialization-related operations.`}</p>
    <p>{`The init command is transformed to a corresponding `}<inlineCode parentName="p">{`npm exec`}</inlineCode>{` operation as
follows:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`npm init foo`}</inlineCode>{` -> `}<inlineCode parentName="li">{`npm exec create-foo`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`npm init @usr/foo`}</inlineCode>{` -> `}<inlineCode parentName="li">{`npm exec @usr/create-foo`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`npm init @usr`}</inlineCode>{` -> `}<inlineCode parentName="li">{`npm exec @usr/create`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`npm init @usr@2.0.0`}</inlineCode>{` -> `}<inlineCode parentName="li">{`npm exec @usr/create@2.0.0`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`npm init @usr/foo@2.0.0`}</inlineCode>{` -> `}<inlineCode parentName="li">{`npm exec @usr/create-foo@2.0.0`}</inlineCode></li>
    </ul>
    <p>{`If the initializer is omitted (by just calling `}<inlineCode parentName="p">{`npm init`}</inlineCode>{`), init will fall
back to legacy init behavior. It will ask you a bunch of questions, and
then write a package.json for you. It will attempt to make reasonable
guesses based on existing fields, dependencies, and options selected. It is
strictly additive, so it will keep any fields and values that were already
set. You can also use `}<inlineCode parentName="p">{`-y`}</inlineCode>{`/`}<inlineCode parentName="p">{`--yes`}</inlineCode>{` to skip the questionnaire altogether. If
you pass `}<inlineCode parentName="p">{`--scope`}</inlineCode>{`, it will create a scoped package.`}</p>
    <p><em parentName="p">{`Note:`}</em>{` if a user already has the `}<inlineCode parentName="p">{`create-<initializer>`}</inlineCode>{` package
globally installed, that will be what `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` uses.  If you want npm
to use the latest version, or another specific version you must specify
it:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`npm init foo@latest`}</inlineCode>{` # fetches and runs the latest `}<inlineCode parentName="li">{`create-foo`}</inlineCode>{` from
the registry`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`npm init foo@1.2.3`}</inlineCode>{` #  runs `}<inlineCode parentName="li">{`create-foo@1.2.3`}</inlineCode>{` specifically`}</li>
    </ul>
    <h4>{`Forwarding additional options`}</h4>
    <p>{`Any additional options will be passed directly to the command, so `}<inlineCode parentName="p">{`npm init
foo -- --hello`}</inlineCode>{` will map to `}<inlineCode parentName="p">{`npm exec -- create-foo --hello`}</inlineCode>{`.`}</p>
    <p>{`To better illustrate how options are forwarded, here's a more evolved
example showing options passed to both the `}<strong parentName="p">{`npm cli`}</strong>{` and a create package,
both following commands are equivalent:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`npm init foo -y --registry=<url> -- --hello -a`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`npm exec -y --registry=<url> -- create-foo --hello -a`}</inlineCode></li>
    </ul>
    <h3>{`Examples`}</h3>
    <p>{`Create a new React-based project using
`}<a parentName="p" {...{
        "href": "https://npm.im/create-react-app"
      }}><inlineCode parentName="a">{`create-react-app`}</inlineCode></a>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm init react-app ./my-react-app
`}</code></pre>
    <p>{`Create a new `}<inlineCode parentName="p">{`esm`}</inlineCode>{`-compatible package using
`}<a parentName="p" {...{
        "href": "https://npm.im/create-esm"
      }}><inlineCode parentName="a">{`create-esm`}</inlineCode></a>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ mkdir my-esm-lib && cd my-esm-lib
$ npm init esm --yes
`}</code></pre>
    <p>{`Generate a plain old package.json using legacy init:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ mkdir my-npm-pkg && cd my-npm-pkg
$ git init
$ npm init
`}</code></pre>
    <p>{`Generate it without having it ask any questions:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm init -y
`}</code></pre>
    <h3>{`Workspaces support`}</h3>
    <p>{`It's possible to create a new workspace within your project by using the
`}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config option. When using `}<inlineCode parentName="p">{`npm init -w <dir>`}</inlineCode>{` the cli will
create the folders and boilerplate expected while also adding a reference
to your project `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` `}<inlineCode parentName="p">{`"workspaces": []`}</inlineCode>{` property in order to make
sure that new generated `}<strong parentName="p">{`workspace`}</strong>{` is properly set up as such.`}</p>
    <p>{`Given a project with no workspaces, e.g:`}</p>
    <pre><code parentName="pre" {...{}}>{`.
+-- package.json
`}</code></pre>
    <p>{`You may generate a new workspace using the legacy init:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm init -w packages/a
`}</code></pre>
    <p>{`That will generate a new folder and `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file, while also updating
your top-level `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` to add the reference to this new workspace:`}</p>
    <pre><code parentName="pre" {...{}}>{`.
+-- package.json
\`-- packages
   \`-- a
       \`-- package.json
`}</code></pre>
    <p>{`The workspaces init also supports the `}<inlineCode parentName="p">{`npm init <initializer> -w <dir>`}</inlineCode>{`
syntax, following the same set of rules explained earlier in the initial
`}<strong parentName="p">{`Description`}</strong>{` section of this page. Similar to the previous example of
creating a new React-based project using
`}<a parentName="p" {...{
        "href": "https://npm.im/create-react-app"
      }}><inlineCode parentName="a">{`create-react-app`}</inlineCode></a>{`, the following syntax
will make sure to create the new react app as a nested `}<strong parentName="p">{`workspace`}</strong>{` within your
project and configure your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` to recognize it as such:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm init -w packages/my-react-app react-app .
`}</code></pre>
    <p>{`This will make sure to generate your react app as expected, one important
consideration to have in mind is that `}<inlineCode parentName="p">{`npm exec`}</inlineCode>{` is going to be run in the
context of the newly created folder for that workspace, and that's the reason
why in this example the initializer uses the initializer name followed with a
dot to represent the current directory in that context, e.g: `}<inlineCode parentName="p">{`react-app .`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{}}>{`.
+-- package.json
\`-- packages
   +-- a
   |   \`-- package.json
   \`-- my-react-app
       +-- README
       +-- package.json
       \`-- ...
`}</code></pre>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`yes`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Automatically answer "yes" to any prompts that npm might print on the
command line.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`force`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Removes various protections against unfortunate side effects, common
mistakes, unnecessary performance degradation, and malicious input.`}</p>
    <ul>
      <li parentName="ul">{`Allow clobbering non-npm files in global installs.`}</li>
      <li parentName="ul">{`Allow the `}<inlineCode parentName="li">{`npm version`}</inlineCode>{` command to work on an unclean git repository.`}</li>
      <li parentName="ul">{`Allow deleting the cache folder with `}<inlineCode parentName="li">{`npm cache clean`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Allow installing packages that have an `}<inlineCode parentName="li">{`engines`}</inlineCode>{` declaration requiring a
different version of npm.`}</li>
      <li parentName="ul">{`Allow installing packages that have an `}<inlineCode parentName="li">{`engines`}</inlineCode>{` declaration requiring a
different version of `}<inlineCode parentName="li">{`node`}</inlineCode>{`, even if `}<inlineCode parentName="li">{`--engine-strict`}</inlineCode>{` is enabled.`}</li>
      <li parentName="ul">{`Allow `}<inlineCode parentName="li">{`npm audit fix`}</inlineCode>{` to install modules outside your stated dependency
range (including SemVer-major changes).`}</li>
      <li parentName="ul">{`Allow unpublishing all versions of a published package.`}</li>
      <li parentName="ul">{`Allow conflicting peerDependencies to be installed in the root project.`}</li>
      <li parentName="ul">{`Implicitly set `}<inlineCode parentName="li">{`--yes`}</inlineCode>{` during `}<inlineCode parentName="li">{`npm init`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Allow clobbering existing values in `}<inlineCode parentName="li">{`npm pkg`}</inlineCode></li>
      <li parentName="ul">{`Allow unpublishing of entire packages (not just a single version).`}</li>
    </ul>
    <p>{`If you don't have a clear idea of what you want to do, it is strongly
recommended that you do not use this option!`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`scope`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: the scope of the current project, if any, or ""`}</li>
      <li parentName="ul">{`Type: String`}</li>
    </ul>
    <p>{`Associate an operation with a scope for a scoped registry.`}</p>
    <p>{`Useful when logging in to or out of a private registry:`}</p>
    <pre><code parentName="pre" {...{}}>{`# log in, linking the scope to the custom registry
npm login --scope=@mycorp --registry=https://registry.mycorp.com

# log out, removing the link and the auth token
npm logout --scope=@mycorp
`}</code></pre>
    <p>{`This will cause `}<inlineCode parentName="p">{`@mycorp`}</inlineCode>{` to be mapped to the registry for future
installation of packages specified according to the pattern
`}<inlineCode parentName="p">{`@mycorp/package`}</inlineCode>{`.`}</p>
    <p>{`This will also cause `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` to create a scoped package.`}</p>
    <pre><code parentName="pre" {...{}}>{`# accept all defaults, and create a package named "@foo/whatever",
# instead of just named "whatever"
npm init --scope=@foo --yes
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces-update`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If set to true, the npm cli will run an update after operations that may
possibly change the workspaces installed to the `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` folder.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`include-workspace-root`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Include the workspace root when workspaces are enabled for a command.`}</p>
    <p>{`When false, specifying individual workspaces via the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config, or
all workspaces via the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` flag, will cause npm to operate only on
the specified workspaces, and not on the root project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/package-spec"
        }}>{`package spec`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://npm.im/init-package-json"
        }}>{`init-package-json module`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/package-json"
        }}>{`package.json`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-version"
        }}>{`npm version`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/scope"
        }}>{`npm scope`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-exec"
        }}>{`npm exec`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/workspaces"
        }}>{`npm workspaces`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      